export type Props = {
  spuId?: string;
  skuId?: string;
};

export enum SectionStatus {
  Loading,
  Success,
  Fail,
}
